import React, { FunctionComponent } from 'react';
import { BetCouponDescription } from '../../../Kambi/types';
import './CouponDescriptionWithOdds.scss';

type CouponDescriptionWithOddsProps = {
  description?: BetCouponDescription;
};

export const CouponDescriptionWithOdds: FunctionComponent<CouponDescriptionWithOddsProps> = ({ description }) => {
  if (!description) return null;

  // bet builder formatting
  const formatDescriptionText = (text: string): React.ReactNode => {
    if (text.includes('~~~')) {
      return text.split('~~~').map((item, index, array) => (
        <React.Fragment key={index}>
          <span>{item.trim()}</span>
          {index < array.length - 1 && (
            <span className="coupon-description-with-odds__separator">
              <br />+{' '}
            </span>
          )}
        </React.Fragment>
      ));
    }

    return text;
  };

  return (
    <span>
      {formatDescriptionText(description.text)}
      {!!description.odds && ` @ `}
      {!!description.oldOdds && <span className="coupon-description-with-odds__value-old">{description.oldOdds}</span>}
      <span className="coupon-description-with-odds__value">{Number(description.odds).toFixed(2)}</span>
    </span>
  );
};
